import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';

// 帶 JWT 取圖並轉成 blob URL(<img src> 無法帶 Authorization header)
const useAuthedImage = (giftId, idx) => {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!giftId) return undefined;
    let objectUrl = null;
    let cancelled = false;
    setLoading(true);
    setError(false);
    setSrc(null);

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/gift/pic`, {
        params: { id: giftId, idx },
        headers: { Authorization: `Bearer ${Cookies.get('jwt_token')}` },
        responseType: 'blob'
      })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [giftId, idx]);

  return { src, loading, error };
};

const BarcodeImage = ({ giftId, idx }) => {
  const { src, loading, error } = useAuthedImage(giftId, idx);
  return (
    <Box className="giftlist-barcode-box">
      {loading && <CircularProgress />}
      {error && <Typography color="error">條碼 {idx} 載入失敗,請稍後再試</Typography>}
      {src && <img className="giftlist-barcode-img" src={src} alt={`條碼 ${idx}`} />}
    </Box>
  );
};

const GiftBarcodeDialog = ({ open, gift, onClose, onMarkUsed, marking }) => {
  const [confirming, setConfirming] = useState(false);
  const barcodeCount = gift?.barcode_count || 1;

  useEffect(() => {
    if (open) setConfirming(false);
  }, [open, gift?.id]);

  if (!gift) return null;

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle className="giftlist-dialog-title">{gift.gift_text}</DialogTitle>
      <DialogContent className="giftlist-dialog-content">
        <Typography className="giftlist-expire">到期日:{gift.date_expired}</Typography>
        {open &&
          Array.from({ length: barcodeCount }, (_, i) => (
            <BarcodeImage key={`${gift.id}-${i + 1}`} giftId={gift.id} idx={i + 1} />
          ))}
      </DialogContent>
      <DialogActions className="giftlist-dialog-actions">
        {confirming ? (
          <>
            <Typography className="giftlist-confirm-text">確定已使用完畢?此動作無法復原</Typography>
            <Button onClick={() => setConfirming(false)} disabled={marking}>取消</Button>
            <Button variant="contained" color="error" onClick={() => onMarkUsed(gift)} disabled={marking}>
              確定
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onClose}>關閉</Button>
            <Button variant="contained" onClick={() => setConfirming(true)}>已使用完畢</Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default GiftBarcodeDialog;
